'use client';

import * as DS from '@aurorasolar/ds';
import { ComponentProps, ReactNode } from 'react';

type Props = Omit<ComponentProps<typeof DS.Text>, 'as' | 'text'> & { children: ReactNode };

export const H3 = ({ children, ...props }: Props) => (
  <DS.Text as="h3" text="h2" {...props}>
    {children}
  </DS.Text>
);
